import { NgModule } from "@angular/core";

import { Faq } from "./components/loren-faq/faq";
import { LorenFaqRoutingModule } from "./loren-faq-routing.module";
import { FaqSection } from "./components/loren-faq-section/faq-section";

@NgModule({
  declarations: [],
  imports: [
    Faq,
    FaqSection,
    LorenFaqRoutingModule,
  ],
})
export class LorenFaqModule {
}
